"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireWildcard"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/asyncToGenerator"));

var _sms = require("@/api/sms");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var vm;
var _default = {
  name: 'sms',
  components: {
    Pagination: _Pagination.default
  },
  filters: {},
  data: function data() {
    return {
      list: null,
      listCP: [],
      activeName: 'common',
      total: 0,
      listLoading: true,
      msTypes: {
        0: '常用短信',
        1: '投诉照片',
        2: '通知短信'
      },
      params1: ['#{客户名称}', '#{工单编号}', '#{客诉编号}', '#{自定义参数}'],
      listQuery: {
        name: undefined,
        msType: undefined,
        page: 1,
        limit: 20,
        sort: 'create_time',
        order: 'desc'
      },
      dataForm: {
        id: undefined,
        msCode: '',
        msName: '',
        isDelete: false,
        msContent: undefined
      },
      deletedOptions: [{
        value: false,
        label: '正常'
      }, {
        value: true,
        label: '删除'
      }],
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑短信模板',
        create: '创建短信模板'
      },
      rules: {
        msCode: [{
          required: true,
          message: '编号不能为空',
          trigger: 'blur'
        }],
        msName: [{
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }],
        msContent: [{
          required: true,
          message: '内容不能为空',
          trigger: 'blur'
        }],
        msType: [{
          required: true,
          message: '短信类型不能为空',
          trigger: 'blur'
        }]
      },
      downloadLoading: false
    };
  },
  beforeCreate: function beforeCreate() {
    vm = this;
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      (0, _sms.listSms)(this.listQuery).then(function (response) {
        _this.list = response.data.data.list;
        _this.total = response.data.data.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.total = 0;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm: function resetForm() {
      this.dataForm = {
        id: undefined,
        msCode: '',
        msName: '',
        isDelete: false,
        msContent: undefined,
        msAccount: 'dh44209'
      };
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
    },
    paramClick: function () {
      var _paramClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var txt, start, end;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                txt = document.querySelector("#msContent");

                if (!(txt.selectionStart || txt.selectionStart === 0)) {
                  _context.next = 11;
                  break;
                }

                start = txt.selectionStart;
                end = txt.selectionEnd;
                this.dataForm.msContent = txt.value.substring(0, start) + params + txt.value.substring(end, txt.value.length);
                _context.next = 7;
                return this.$nextTick();

              case 7:
                txt.focus();
                txt.setSelectionRange(end + txt.value.length, end + txt.value.length);
                _context.next = 12;
                break;

              case 11:
                this.dataForm.msContent += params;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function paramClick(_x) {
        return _paramClick.apply(this, arguments);
      }

      return paramClick;
    }(),
    createData: function createData() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _sms.createSms)(_this3.dataForm).then(function (response) {
            _this3.list.unshift(response.data.data);

            _this3.dialogFormVisible = false;

            _this3.$notify.success({
              title: '成功',
              message: '创建成功'
            });
          }).catch(function (response) {
            _this3.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this4 = this;

      this.dataForm = Object.assign({}, row);
      console.info(this.dataForm);
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this4.$refs['dataForm'].clearValidate();
      });
    },
    updateData: function updateData() {
      var _this5 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _sms.updateSms)(_this5.dataForm).then(function () {
            var _iterator = (0, _createForOfIteratorHelper2.default)(_this5.list),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var v = _step.value;

                if (v.id === _this5.dataForm.id) {
                  var index = _this5.list.indexOf(v);

                  _this5.list.splice(index, 1, _this5.dataForm);

                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this5.dialogFormVisible = false;

            _this5.$notify.success({
              title: '成功',
              message: '更新成功'
            });
          }).catch(function (response) {
            _this5.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.$confirm("确定要删除此短信？", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _sms.deleteSms)(row).then(function (response) {
          _this6.$notify.success({
            title: '成功',
            message: '删除成功'
          });

          var index = _this6.list.indexOf(row);

          _this6.list.splice(index, 1);
        }).catch(function (response) {
          _this6.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    handleDownload: function handleDownload() {
      var _this7 = this;

      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['问题ID', '问题内容', '问题回复'];
        var filterVal = ['id', 'question', 'answer'];
        excel.export_json_to_excel2(tHeader, _this7.list, filterVal, '常见问题信息');
        _this7.downloadLoading = false;
      });
    }
  }
};
exports.default = _default;